import React, { PropsWithChildren } from 'react'
import LabeledContainer from './LabeledContainer'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import { INCLUSIONS_TITLE_BONUS } from 'constants/inclusions'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

interface Props {
  duration?: number;
}

function BonusInclusionsLabeledContainer(props: PropsWithChildren<Props>) {
  const { duration, children } = props

  return <LabeledContainer
  colour="highlight-secondary"
  data-testid="bonus-inclusions-labeled-container"
  labels={<>
    <CSSBreakpoint not="tablet">
      {!!duration && <PromotionLabel variant="premium" format="propercase">{INCLUSIONS_TITLE_BONUS} for {duration} night stays</PromotionLabel>}
      {!duration && <PromotionLabel variant="premium" format="propercase">{INCLUSIONS_TITLE_BONUS}</PromotionLabel>}
    </CSSBreakpoint>
    <CSSBreakpoint only="tablet">
      <PromotionLabel variant="premium" format="propercase">{INCLUSIONS_TITLE_BONUS}</PromotionLabel>
    </CSSBreakpoint>
  </>}
  >
    {children}
  </LabeledContainer>
}

export default BonusInclusionsLabeledContainer
